import { useNavigate } from 'react-router';

import { STANDARD_HEALTH_PROFILES_PATH } from '@shared/constants/paths';
import { SESSION_KEY } from '@shared/constants/sessionKey';

const useNavigateStandardHealthProfile = () => {
  const navigate = useNavigate();

  const setStandardHealthProfileStorage = () => {
    sessionStorage.setItem(SESSION_KEY.standardHealthProfile, 'true');
  };

  const isStandardHealthProfile = sessionStorage.getItem(SESSION_KEY.standardHealthProfile) === 'true';

  const clearStandardHealthProfileStorage = () => {
    sessionStorage.removeItem(SESSION_KEY.standardHealthProfile);
  };

  const navigateToStandardHealthProfile = () => {
    navigate(STANDARD_HEALTH_PROFILES_PATH, {
      replace: true,
    });
    clearStandardHealthProfileStorage();
  };

  return {
    clearStandardHealthProfileStorage,
    isStandardHealthProfile,
    navigateToStandardHealthProfile,
    setStandardHealthProfileStorage,
  };
};

export default useNavigateStandardHealthProfile;
